import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import qs from 'qs';
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { E_CompanyChargeMode, E_HitCompanySource } from '@/apis/service/CompanyApi.types';
import { OAuthRespKeysForForm, OAuthRespKeysForStatic } from '@/views/company-next/CompanySso/SsoOAuth/oauth.common';
let CompanySettingService = class CompanySettingService {
    constructor(i18n, companyApi, packageApi, accountApi, miscApi, institutionApi, passportSamlUrls, passportOauthUrls, commonService, systemService, authService) {
        this.i18n = i18n;
        this.companyApi = companyApi;
        this.packageApi = packageApi;
        this.accountApi = accountApi;
        this.miscApi = miscApi;
        this.institutionApi = institutionApi;
        this.passportSamlUrls = passportSamlUrls;
        this.passportOauthUrls = passportOauthUrls;
        this.commonService = commonService;
        this.systemService = systemService;
        this.authService = authService;
        this.patchCompanySetting = this.companyApi.patchCompanySetting;
        this.patchCompanyTrialSecuritySettings = this.companyApi.patchCompanyTrialSecuritySettings;
        /**
         * 常规设置
         */
        this.patchCompanyGeneralSetting = this.companyApi.patchCompanyGeneralSetting;
        this.getCheckCompanyName = this.companyApi.getCheckCompanyName;
        /**
         * sso 设置
         */
        this.patchCompanySsoSetting = this.companyApi.patchCompanySsoSetting;
        this.patchCompanySettingForm = this.companyApi.patchCompanySettingForm;
        this.getCompanyInfo = this.companyApi.getCompanyInfo;
        this.getCompanySecurity = this.companyApi.getCompanySecurity;
        this.getCompanySSOQueryCompanyId = this.companyApi.getCompanySSOQueryCompanyId;
        this.postCompanySsoKeepAttribute = this.companyApi.postCompanySsoKeepAttribute;
        this.getPublicKeyApi = this.companyApi.getPublicKeyApi;
        /** grant */
        this.getCompanyGrant = this.companyApi.getCompanyGrant;
        this.getWhiteLabel = this.miscApi.getWhiteLabel;
        this.getCompanyPrivilege = this.packageApi.getCompanyPrivilege;
        this.getCompanyFakeActiveUsers = this.accountApi.getCompanyFakeActiveUsers;
        this.getIdps = this.institutionApi.getIdps;
        this.patchModifyCompanyPrivilege = this.packageApi.patchModifyCompanyPrivilege;
        /** 系统限制 */
        this.getSystemLimit = this.companyApi.getSystemLimit;
        this.patchSystemLimit = (company_id, data) => {
            return this.companyApi.patchSystemLimit(company_id, data);
        };
        this.getMetaDataChecked = this.companyApi.getMetaDataChecked;
        this.getCompanyCustomizedAuthUrl = this.companyApi.getCompanyCustomizedAuthUrl;
        this.postCompanySsoOaIp = this.companyApi.postCompanySsoOaIp;
        this.getCompanySsoOaIp = this.companyApi.getCompanySsoOaIp;
        this.patchJwtLimit = (company_id, data) => {
            return this.companyApi.patchJwtLimit(company_id, data);
        };
        this.postCompaniesUnbindUserCarsi = this.companyApi.postCompaniesUnbindUserCarsi;
    }
    get SSOUrl() {
        return this.passportSamlUrls.ssoUrl;
    }
    buildSamlLoginUrl(idp, redirect_uri) {
        const params = {
            idp,
            redirect_uri: null,
        };
        if (redirect_uri) {
            params.redirect_uri = redirect_uri;
        }
        return this.passportSamlUrls.samlLogin + '?' + qs.stringify(params, {
            skipNulls: true,
        });
    }
    buildOAuthStaticAttrs(companyInfo) {
        return {
            // @ts-ignore
            login_url: companyInfo.oauth2_sso_enabled ? `${this.passportOauthUrls.login}/${companyInfo.id}` : '',
            // @ts-ignore
            oauth2_redirect_uri: companyInfo.oauth2_redirect_uri || `${this.passportOauthUrls.redirect}/${companyInfo.id}`,
            ..._.pick(companyInfo, OAuthRespKeysForStatic),
        };
    }
    buildCrmUrl(params) {
        if (!params) {
            return null;
        }
        const { xiaoshouyi_id, salesforce_id, } = params;
        if (xiaoshouyi_id) {
            const link = `https://crm-tencent.xiaoshouyi.com/bff/neoweb#/account_detail?id=${xiaoshouyi_id}&new_window_detail=true`;
            return {
                link,
                crm: this.i18n.t('backoffice.common.xiaoshouyi'),
            };
        }
        else if (salesforce_id) {
            const link = `https://patsnap.lightning.force.com/lightning/r/Account/${salesforce_id}/view`;
            return {
                link,
                crm: this.i18n.t('backoffice.common.salesforce'),
            };
        }
        else {
            return null;
        }
    }
    crmHrefInfo(companyInfo) {
        const checkCrmChargeModes = [
            E_CompanyChargeMode.FREE,
            E_CompanyChargeMode.COMMERCIAL,
            E_CompanyChargeMode.NOT_RENEW,
            E_CompanyChargeMode.TRIAL
        ];
        if (!checkCrmChargeModes.includes(companyInfo?.charge_mode)) {
            return null;
        }
        return this.buildCrmUrl(companyInfo);
    }
    getSsoOpenedMethod(companyInfo) {
        const list = [
            { label: 'OAuth 2.0', displayKey: OAuthRespKeysForForm[0] },
            { label: 'SAML 2.0', displayKey: 'allow_saml_display' },
            { label: 'JWT', displayKey: 'third_login' },
            { label: 'CARSI', displayKey: 'allow_carsi_display' },
            { label: this.i18n.t('backoffice.company.settingMap.dingTalk'), displayKey: 'dingtalk_sso_enabled' },
            { label: this.i18n.t('backoffice.company.settingMap.wechatWork'), displayKey: 'wechat_enterprise_sso_enabled' },
            { label: this.i18n.t('backoffice.company.settingMap.feiShu'), displayKey: 'feishu_sso_enabled' }
        ];
        const item = _.find(list, f => companyInfo[f.displayKey]);
        if (item)
            return item;
        return null;
    }
    getQrCodeByUrl(url) {
        return this.companyApi.getQrCodeByUrl(url);
    }
    get HitCompanySource() {
        if (this.systemService.IsCn) {
            return E_HitCompanySource.Normal;
        }
        else {
            return E_HitCompanySource.Tianyancha;
        }
    }
    get CountiesOptions() {
        return _.map(this.commonService.CountriesSelect, country => {
            return {
                ...country,
                text: this.i18n.locale === 'cn' ? country.zh_CN : country.en_US,
                value: country.id,
            };
        });
    }
    getCountryName(countryId) {
        return _.find(this.CountiesOptions, { value: countryId })?.text;
    }
    get AreaOptions() {
        return _.map(this.commonService.AreaSelect, area => {
            return {
                value: area,
                text: this.i18n.t(`enum.E_CompanyArea.${area}`),
            };
        });
    }
    get TimezonesOptions() {
        return this.commonService.TimezonesSelect;
    }
    getTimezoneName(timezone) {
        return _.find(this.TimezonesOptions, { value: timezone })?.label;
    }
    canChangeCompanyName(companyInfo) {
        if (!companyInfo) {
            return false;
        }
        if (companyInfo.charge_mode === E_CompanyChargeMode.COOPERATIVE || companyInfo.charge_mode === E_CompanyChargeMode.INTERNAL) {
            return true;
        }
        const crmHrefInfo = this.crmHrefInfo(companyInfo);
        if (companyInfo.charge_mode === E_CompanyChargeMode.FREE && !crmHrefInfo) {
            return true;
        }
        if (_.includes([E_CompanyChargeMode.COMMERCIAL, E_CompanyChargeMode.TRIAL, E_CompanyChargeMode.NOT_RENEW], companyInfo.charge_mode) && !crmHrefInfo) {
            return true;
        }
        return false;
    }
    get canChangeSalesAndCs() {
        if (this.authService.IsAdmin || this.authService.IsSuperAdmin || this.authService.canEditAccountManager) {
            return true;
        }
    }
};
CompanySettingService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.CompanyApi)),
    __param(2, inject(Symbols.PackageApi)),
    __param(3, inject(Symbols.AccountApi)),
    __param(4, inject(Symbols.MiscApi)),
    __param(5, inject(Symbols.InstitutionApi)),
    __param(6, inject(Symbols.PassportSamlUrls)),
    __param(7, inject(Symbols.PassportOauthUrls)),
    __param(8, inject(Symbols.CommonService)),
    __param(9, inject(Symbols.SystemService)),
    __param(10, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object])
], CompanySettingService);
export { CompanySettingService };
